import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "flex items-center mb-4" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = {
    key: 0,
    id: "campaign-code-orders",
    class: "admin-table"
};
const _hoisted_5 = { class: "colored-row" };
const _hoisted_6 = { class: "w-16" };
const _hoisted_7 = ["aria-labelledby"];
const _hoisted_8 = ["id"];
const _hoisted_9 = { class: "text-slate-500" };
const _hoisted_10 = { class: "text-center font-medium" };
const _hoisted_11 = { class: "text-lg font-semibold" };
const _hoisted_12 = { class: "font-medium" };
const _hoisted_13 = { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" };
const _hoisted_14 = {
    class: "text-lg leading-6 font-medium text-slate-900",
    id: "modal-title"
};
const _hoisted_15 = { class: "my-loading" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ConfirmationModal = _resolveComponent("ConfirmationModal");
    const _component_Loading = _resolveComponent("Loading");
    const _component_VueEternalLoading = _resolveComponent("VueEternalLoading");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            (!_ctx.order.isLoaded())
                ? (_openBlock(), _createElementBlock("h1", _hoisted_2, "Campaign Code Order"))
                : (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(_ctx.order.order), 1)),
            _createElementVNode("nav", null, [
                _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.order.navigation.goBack && _ctx.order.navigation.goBack(...args))),
                    type: "button",
                    class: "alt"
                }, "Go Back")
            ])
        ]),
        (_ctx.order.hasResults())
            ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
                _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                            _createElementVNode("table", null, [
                                _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", { scope: "col" }, " "),
                                        _createElementVNode("th", { scope: "col" }, "Reference"),
                                        _createElementVNode("th", { scope: "col" }, " "),
                                        _createElementVNode("th", {
                                            scope: "col",
                                            class: "text-center"
                                        }, "Complete / Total"),
                                        _createElementVNode("th", { scope: "col" }, " "),
                                        _createElementVNode("th", { scope: "col" }, " ")
                                    ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.getData(), (item) => {
                                        return (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                                            _createElementVNode("td", _hoisted_6, [
                                                (_openBlock(), _createElementBlock("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    class: "h-10 w-10 text-slate-400 mx-auto",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    role: "img",
                                                    focusable: "false",
                                                    "aria-labelledby": item.reference
                                                }, [...(_cache[1] || (_cache[1] = [
                                                        _createElementVNode("title", null, "Order", -1),
                                                        _createElementVNode("path", {
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round",
                                                            d: "M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
                                                        }, null, -1)
                                                    ]))], 8, _hoisted_7))
                                            ]),
                                            _createElementVNode("td", null, [
                                                _createElementVNode("span", {
                                                    class: "font-medium block",
                                                    id: item.reference
                                                }, "Order Reference: " + _toDisplayString(item.reference), 9, _hoisted_8),
                                                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.f.formatDateShort(item.created_at)), 1)
                                            ]),
                                            _createElementVNode("td", null, [
                                                _createElementVNode("span", {
                                                    class: _normalizeClass(["status-box", {
                                                            'status-processing': item.item_status === 'processing',
                                                            'status-complete': item.item_status === 'complete',
                                                        }])
                                                }, [
                                                    _createElementVNode("span", null, _toDisplayString(item.item_status), 1),
                                                    _cache[2] || (_cache[2] = _createElementVNode("span", null, [
                                                        _createElementVNode("span"),
                                                        _createElementVNode("span")
                                                    ], -1))
                                                ], 2)
                                            ]),
                                            _createElementVNode("td", _hoisted_10, [
                                                _createElementVNode("span", null, _toDisplayString(item.processed), 1),
                                                _cache[3] || (_cache[3] = _createTextVNode()),
                                                _createElementVNode("span", _hoisted_11, "/ " + _toDisplayString(item.quantity), 1)
                                            ]),
                                            _cache[6] || (_cache[6] = _createElementVNode("td", null, "   ", -1)),
                                            _createElementVNode("td", _hoisted_12, [
                                                (item.item_status === 'processing' && _ctx.permissions.isAdmin())
                                                    ? (_openBlock(), _createBlock(_component_ConfirmationModal, {
                                                        key: 0,
                                                        buttonClass: "btn mr-2 w-24",
                                                        buttonText: "Check",
                                                        onConfirmAction: ($event) => (_ctx.order.checkReference(item.reference))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-brand-100 sm:mx-0 sm:h-10 sm:w-10" }, [
                                                                _createElementVNode("svg", {
                                                                    class: "h-6 w-6 text-brand-600",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    fill: "none",
                                                                    viewBox: "0 0 24 24",
                                                                    stroke: "currentColor",
                                                                    role: "img",
                                                                    focusable: "false",
                                                                    "aria-label": "Warning"
                                                                }, [
                                                                    _createElementVNode("path", {
                                                                        "stroke-linecap": "round",
                                                                        "stroke-linejoin": "round",
                                                                        "stroke-width": "2",
                                                                        d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                                                    })
                                                                ])
                                                            ], -1)),
                                                            _createElementVNode("div", _hoisted_13, [
                                                                _createElementVNode("h3", _hoisted_14, "Check " + _toDisplayString(item.reference), 1),
                                                                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex mt-2" }, [
                                                                    _createElementVNode("p", { class: "text-sm text-slate-500" }, " Check the status of ordered codes from the processor. ")
                                                                ], -1))
                                                            ])
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["onConfirmAction"]))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ]));
                                    }), 256))
                                ])
                            ])
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        _createVNode(_component_VueEternalLoading, { load: _ctx.load }, {
            loading: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_Loading, { message: "Loading Campaigns" })
                ])
            ]),
            "no-more": _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("div", { class: "my-no-more" }, [
                        _createElementVNode("div", { class: "my-6 text-center" }, [
                            _createElementVNode("a", {
                                href: "#campaign-code-orders",
                                class: "flex justify-center"
                            }, [
                                _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "h-5 w-5 mr-2",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    focusable: "true"
                                }, [
                                    _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        d: "M5 10l7-7m0 0l7 7m-7-7v18"
                                    })
                                ]),
                                _createTextVNode(" Top of Page ")
                            ])
                        ])
                    ], -1)
                ]))]),
            "no-results": _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("div", { class: "no-results panel p-10 mt-4" }, [
                        _createElementVNode("div", { class: "text-slate-300 my-6" }, [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-20 w-20 mx-auto",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                "stroke-width": "2"
                            }, [
                                _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
                                })
                            ])
                        ]),
                        _createElementVNode("h2", { class: "text-slate-600 font-medium text-2xl text-center" }, "No Campaign Codes Available"),
                        _createElementVNode("p", { class: "text-center mt-4 text-sm text-slate-700" }, " We could not find any campaign codes. ")
                    ], -1)
                ]))]),
            error: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createElementVNode("div", { class: "no-results panel p-10 mt-4" }, [
                        _createElementVNode("div", { class: "text-slate-300 my-6" }, [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-20 w-20 mx-auto",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                role: "img",
                                focusable: "false",
                                "aria-label": "An Error Occurred"
                            }, [
                                _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                })
                            ])
                        ]),
                        _createElementVNode("h2", { class: "text-slate-600 font-medium text-2xl text-center" }, "An Error Occurred"),
                        _createElementVNode("p", { class: "text-center mt-4 text-sm text-slate-700" }, " An error occurred, please try again. If this problem persists please contact support. ")
                    ], -1)
                ]))]),
            _: 1
        }, 8, ["load"])
    ]));
}
